'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["small", "size", "children", "semanticColor", "isFocus", "isActive"];
import React, { useContext } from 'react';
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { textClass } from "../../styles/index.mjs";
import { VisuallyHidden } from "../VisuallyHidden/index.mjs";
import { Checkbox } from "./Checkbox.mjs";
import { Indicator } from "./Indicator.mjs";
import { Label } from "./Label.mjs";
import { Wrapper } from "./Wrapper.mjs";
/**
 * FormToggle allow users to switch the state of a single item on or off, within a Form component.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-formtoggle--docs) |
 * [Encore site](https://encore.spotify.net/web/components/selectors#toggle) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormToggle) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12302&t=ouXhP8WPuklpY62v-1)
 */
export var FormToggle = /*#__PURE__*/React.forwardRef(function FormToggle(_ref, ref) {
  var small = _ref.small,
    size = _ref.size,
    children = _ref.children,
    _ref$semanticColor = _ref.semanticColor,
    semanticColor = _ref$semanticColor === void 0 ? 'essentialBrightAccent' : _ref$semanticColor,
    isFocus = _ref.isFocus,
    isActive = _ref.isActive,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  return /*#__PURE__*/React.createElement(Checkbox, {
    "data-encore-id": ENCORE_DATA_IDS.FormToggle
  }, /*#__PURE__*/React.createElement(VisuallyHidden, Object.assign({
    component: "input",
    type: "checkbox",
    ref: ref
  }, props)), /*#__PURE__*/React.createElement(Wrapper, {
    $isUsingKeyboard: isUsingKeyboard,
    $semanticColor: semanticColor,
    $isFocus: isFocus,
    $isActive: isActive
  }, /*#__PURE__*/React.createElement(Indicator, null)), children && /*#__PURE__*/React.createElement(Label, {
    className: small || size === 'small' ? textClass('marginal') : textClass('bodySmall')
  }, children));
});